export const isFirebaseConfigured = Boolean(import.meta.env.VITE_FIREBASE_API_KEY);

export let firebaseApp: any = null;
export let auth: any = null;

async function initFirebase() {
  if (!isFirebaseConfigured) return;
  const { initializeApp } = await import("firebase/app");
  const { getAuth } = await import("firebase/auth");
  firebaseApp = initializeApp({
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  });
  auth = getAuth(firebaseApp);
}

export const firebaseReady = initFirebase();
